import React, {useState} from 'react';
import {Stack} from 'react-bootstrap';
import {Outlet} from 'react-router-dom';
import {MenuItem, Sidebar} from "../sidebar/sidebar.component";
import {NavbarComponent} from "../navbar/navbar.component";
import './main-layout.component.sass';

type Props = { menuItems: MenuItem[], searchBar?: boolean };
type States = { sidebarCollapsed: boolean };
export const MainLayout: React.FunctionComponent<Props> = ({menuItems, searchBar}) => {
    const [states, setStates] = useState({sidebarCollapsed: false} as States);

    return (
        <Stack className="min-vh-100 min-vw-100 align-items-start" direction="horizontal">
            <div className="sl-sidebar-container">
                <Sidebar menuItems={menuItems}
                         onCollapsed={(collapsed) => setStates({...states, sidebarCollapsed: collapsed})}/>
            </div>
            <Stack>
                <NavbarComponent searchBar={searchBar}/>
                <div className={`sl-page-content ${states.sidebarCollapsed ? 'sl-page-content--wide' : ''}`}>
                    <Outlet/>
                </div>
            </Stack>
        </Stack>
    );
}
